import LabRepository from "./LabRepository";

const resource = "/prep-workflow";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  updateSampleType(sample_type_id, payload) {
    return LabRepository.put(
      `${resource}/sample-type/${sample_type_id}/update`,
      payload
    );
  },
  updateProcesses(payload) {
    return LabRepository.put(
      `${resource}/sample-type/${payload.sample_type_id}/processes`,
      payload
    );
  },
  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  }
};
